module.exports = __webpack_public_path__ + "static/Zhenhao Li.0ab3e69c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Zhenhao Li.jpg
// module id = 1248
// module chunks = 6166952557895